import {AbstractDTO} from '../abstract';
import {Template} from './template';
import {Factor} from './factor';
import {RuleDTO as Rule} from '../forms/rule';

export class Block extends AbstractDTO {
    mandatory: boolean;
    startFromZero: boolean;
    endType: string;
    factors: any[] = [];
    rules: any[] = [];
    status: boolean;
    isPoa: boolean = false;
    updatedPrice: number = 0;
    additionPrice: number = 0;
    priceVar: string;
    additionPriceVar: string;
    linkedTemplate: Template;

    constructor(attributes?: object) {
        super(attributes);
        Object.assign(this, attributes);
        attributes = attributes ? attributes : {};
        this.mandatory = (attributes['mandatory'] == 1);
        this.startFromZero = (attributes['startFromZero'] == 1);
        this.endType = attributes['endType'] || 'all';
        this.rules = Rule.createFromArray(attributes['rules']) || [];
        this.status = attributes['status'] || false;
        this.priceVar = attributes['priceVar'] || '';
        this.additionPriceVar = attributes['additionPriceVar'] || '';
        this.factors = Factor.createFromArray(attributes['factors']) || [];
        this.linkedTemplate = attributes['linkedTemplate'] ? Template.create(attributes['linkedTemplate']) : null;
    }

}
